<template>
  <div class="fixed top-4 right-4 space-y-2 z-50">
    <div
      v-for="alert in alerts"
      :key="alert.id"
      :class="['px-4 py-2 rounded shadow-md text-white', alertClass(alert.type)]"
    >
      <div class="flex justify-between items-center">
        <span>{{ alert.message }}</span>
        <button @click="removeAlert(alert.id)" class="ml-4 text-white font-bold">&times;</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useAlertStore } from "@/stores/alert";
import { storeToRefs } from "pinia";

const alertStore = useAlertStore();
const { alerts } = storeToRefs(alertStore);
const { removeAlert } = alertStore;

const alertClass = (type) => {
  switch (type) {
    case "success":
      return "bg-green-600";
    case "warning":
      return "bg-yellow-500";
    case "info":
      return "bg-blue-500";
    default:
      return "bg-red-600";
  }
};
</script>
